/**
 * A camera do mundo (docs/21 secao 5): segue o personagem e para nas bordas do mapa. Logica pura.
 *
 * Tudo em pixels de TELA, ja com o zoom aplicado.
 */

export type Viewport = { width: number; height: number }

/**
 * O zoom inteiro que deixa ~12 tiles de 16 px no menor lado da tela, entre 2 e 4. Inteiro de proposito: pixel
 * art com zoom fracionario fica com tiles de larguras diferentes.
 *
 * O mapa de 32 px (ADR 0062) mostra ~16 tiles, entre 1 e 3: o personagem tem 3 tiles de altura, e com 12 ele
 * ocuparia um quarto da tela.
 */
export function zoomFor(viewport: Viewport, tileSize: number): number {
  const large = tileSize >= 32
  const ideal = Math.min(viewport.width, viewport.height) / (tileSize * (large ? 16 : 12))
  return Math.max(large ? 1 : 2, Math.min(large ? 3 : 4, Math.round(ideal)))
}

/**
 * O deslocamento do mundo para centrar o alvo, preso as bordas. Se o mapa e menor que a tela num eixo, ele
 * fica centrado nesse eixo.
 */
export function cameraOffset(
  target: { x: number; y: number },
  world: Viewport,
  viewport: Viewport,
): { x: number; y: number } {
  const axis = (center: number, worldSize: number, viewSize: number): number => {
    if (worldSize <= viewSize) return Math.round((viewSize - worldSize) / 2)
    const desired = viewSize / 2 - center
    return Math.round(Math.min(0, Math.max(viewSize - worldSize, desired)))
  }
  return { x: axis(target.x, world.width, viewport.width), y: axis(target.y, world.height, viewport.height) }
}

/** O tile sob um ponto da tela, dado o deslocamento da camera. */
export function tileAt(
  point: { x: number; y: number },
  offset: { x: number; y: number },
  tilePixels: number,
): { x: number; y: number } {
  return { x: Math.floor((point.x - offset.x) / tilePixels), y: Math.floor((point.y - offset.y) / tilePixels) }
}
